module.exports = __webpack_public_path__ + "img/coach-slide2.5fb9632e.png";